<div class="row page-header no-print">
    <div class="col-12">
        <h1>Scheduling <small>Work Order and other equipment scheduling and planning</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs" (activeIdChange)="tabChanged()">
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Work Orders</a>
            <ng-template ngbNavContent>
                <div class="row" style="margin-top: 20px">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="workOrdersGrid"></action-toolbar-count>
                                    <action-toolbar-search name="search" [(ngModel)]="workOrdersGrid.filter"></action-toolbar-search>
                                    <grid-export [grid]="workOrdersGridFlexGrid" [name]="'Work Orders'"></grid-export>
                                    <div class="input-header-group">
                                        <span class="input-header">Mechanic</span>
                                        <wj-combo-box
                                            name="selectedMechanic"
                                            [ngModel]="selectedMechanic()"
                                            (ngModelChange)="selectedMechanic.set($event)"
                                            [itemsSource]="mechanicsList"
                                            [displayMemberPath]="'display'"
                                            [selectedValuePath]="'value'"
                                            [isRequired]="false"
                                        >
                                        </wj-combo-box>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <wj-flex-grid
                                    #workOrdersGridFlexGrid
                                    appAutoSize
                                    (initialized)="workOrdersGrid.initialize(workOrdersGridFlexGrid)"
                                    (destroy)="workOrdersGrid.destroy()"
                                    [itemsSource]="workOrdersGrid.view"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column [header]="'Work Order'" [binding]="'workOrder'" [width]="80" [isReadOnly]="true">
                                        <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                                            <a
                                                href="javascript:void(0)"
                                                (click)="openWorkOrderDetails(cell.item)"
                                                style="color: #007bff; text-decoration: underline; cursor: pointer"
                                            >
                                                {{ cell.item.workOrder }}
                                            </a>
                                        </ng-template>
                                    </wj-flex-grid-column>
                                    <!-- <wj-flex-grid-column [header]="'Equipment'" [binding]="'equipment'" [width]="120"></wj-flex-grid-column> -->
                                    <wj-flex-grid-column
                                        [header]="'Equipment'"
                                        [binding]="'equipmentDescription'"
                                        [width]="'*'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'WO Description'"
                                        [binding]="'description'"
                                        [width]="'*'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Mechanic'" [binding]="'mechanic'" [width]="200"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Date Created'"
                                        [binding]="'dateCreated'"
                                        [format]="'MM/dd/yyyy'"
                                        [width]="130"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Date Scheduled'"
                                        [binding]="'dateSched'"
                                        [format]="'MM/dd/yyyy'"
                                        [width]="130"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Date Due'"
                                        [binding]="'dateDue'"
                                        [format]="'MM/dd/yyyy'"
                                        [width]="130"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav"></div>
</div>
